import { useFieldArray, useFormContext } from 'react-hook-form';

import { Tooltip } from 'primereact/tooltip';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { classNames } from 'primereact/utils';
import UniversityVisitingStaffDialog from './UniversityVisitingStaffDialog';

export default function UniversityVisitingStaffTable({ control, shouldUpdateFromDocx }) {
  // #region Data
  const { t } = useTranslation();
  const { dirtyFields } = useFormContext();

  const universityVisitingStaffRef = useRef();

  const { fields, insert, update, remove } = useFieldArray({
    control,
    name: 'others.universityVisitingStaff',
  });
  // #endregion
  // #region Event

  // #endregion
  return (
    <>
      <div className="form-table mt-2">
        <table className="mb-2">
          <thead>
            <tr>
              <th className="text-center" style={{ minWidth: 50, width: 50 }}>
                {t('formLayout.numericalOrder')}
              </th>
              <th className="text-center" style={{ minWidth: 150, width: '20%' }}>
                {t('scientificProfile.otherInfo.universityVisitingStaff.timePeriod')}
              </th>
              <th className="text-center" style={{ minWidth: 100, width: '40%' }}>
                {t('scientificProfile.otherInfo.universityVisitingStaff.universityName')}
              </th>
              <th className="text-center" style={{ minWidth: 100, width: '30%' }}>
                {t('scientificProfile.otherInfo.universityVisitingStaff.participationContent')}
              </th>
              <th className="text-center float" style={{ minWidth: 80, width: 80 }}>
                {t('formLayout.action.label')}
              </th>
            </tr>
          </thead>
          <tbody>
            {fields?.map((item, index) => (
              <tr
                key={item.id ?? index}
                className={classNames({
                  highlighted: shouldUpdateFromDocx && dirtyFields.others?.universityVisitingStaff,
                })}
              >
                <td className="text-center">{index + 1}</td>
                <td className="text-center">
                  {item?.start ? new Date(item?.start).toLocaleDateString('en-GB') : ''} -{' '}
                  {item?.end ? new Date(item?.end).toLocaleDateString('en-GB') : ''}
                </td>
                <td>{item?.universityName}</td>
                <td>{item?.participationContent}</td>

                <td
                  className={`flex flex-column float text-center p-0 border-none ${
                    index !== 0 ? 'border-top-1' : ''
                  }`}
                >
                  <i
                    onClick={() => {
                      universityVisitingStaffRef.current.open({
                        insert,
                        index: index + 1,
                        type: 'INSERT',
                      });
                    }}
                    className="insert-icon pi pi-plus text-primary cursor-pointer my-1"
                    data-pr-tooltip={t('formLayout.action.insert')}
                    data-pr-position="left"
                  />
                  <Tooltip target=".insert-icon" />

                  <i
                    onClick={() => {
                      universityVisitingStaffRef.current.open({
                        update,
                        index,
                        value: fields[index],
                        type: 'UPDATE',
                      });
                    }}
                    className="edit-icon pi pi-pencil text-primary cursor-pointer mb-1"
                    data-pr-tooltip={t('formLayout.action.edit')}
                    data-pr-position="left"
                  />
                  <Tooltip target=".edit-icon" />

                  <i
                    onClick={() => remove(index)}
                    className="remove-icon pi pi-times text-red-700 cursor-pointer mb-1"
                    data-pr-tooltip={t('formLayout.action.remove')}
                    data-pr-position="left"
                  />
                  <Tooltip target=".remove-icon" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {fields?.length === 0 && (
          <div className="flex justify-content-center my-2">
            <i
              onClick={() => {
                universityVisitingStaffRef.current.open({
                  insert,
                  index: 0,
                  type: 'INSERT',
                });
              }}
              className="add-university-visiting-staff pi pi-plus text-primary cursor-pointer bg-primary p-1 border-circle"
              data-pr-tooltip={t('formLayout.action.add')}
              data-pr-position="left"
            />
            <Tooltip target=".add-university-visiting-staff" />
          </div>
        )}
      </div>
      <UniversityVisitingStaffDialog ref={universityVisitingStaffRef} />
    </>
  );
}

UniversityVisitingStaffTable.propTypes = {
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  shouldUpdateFromDocx: PropTypes.bool,
};

UniversityVisitingStaffTable.defaultProps = {
  shouldUpdateFromDocx: false,
};
